import { atom } from "jotai";
import { atomWithStorage, createJSONStorage } from "jotai/utils";

import { OnboardingSteps } from "../../../utils/constants";
import { STORED_ATOM_KEYS } from "../constants";

const onboardingStepSessionStorageJson =
  createJSONStorage<OnboardingSteps | null>(() => sessionStorage);

export const signUpStepAtom = atom<OnboardingSteps | null>(null);

export const onboardingStepAtom = atomWithStorage<OnboardingSteps | null>(
  STORED_ATOM_KEYS.ONBOARDING_STEP,
  null,
  onboardingStepSessionStorageJson,
  { getOnInit: true },
);
onboardingStepAtom.debugLabel = "onboarding-step-atom-stored";
